const keyfobFormResources = {
    labelKeyfobStep: '1. Key Fob',
    infoKeyfob: 'Please enter your key fob',
    labelKeyfob: 'Key Fob',
    facilityMemberID: 'facilityMemberID'
};
export default keyfobFormResources;